import {Component, forwardRef, Input, ViewChild} from '@angular/core';
import {SelectItem} from "../../core/interfaces/admin.interface";
import {NgSelectComponent} from "@ng-select/ng-select";
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {CommonService} from "../services/common.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-enum-select',
    exportAs: 'ngModel',
    templateUrl: './enum-select.component.html',
    styleUrls: ['./enum-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EnumSelectComponent),
            multi: true
        }
    ]
})
export class EnumSelectComponent implements ControlValueAccessor {

    @ViewChild(NgSelectComponent)
    select: NgSelectComponent
    items: SelectItem[]
    @Input()
    placeHolder: string = 'item.bomType_select'
    @Input()
    clearable: boolean
    @Input()
    enumName

    bomType: FormControl<string>
    onChange: (value: string) => void = () => {};
    onTouched: () => void = () => {};
    value: string

    constructor(
        private commonService: CommonService,
        private translateService: TranslateService,
    ) {
        this.bomType = new FormControl()
    }

    onInput(value: any): void {
        this.value = value;
        this.onChange(value);
    }
    registerOnChange(fn: any): void {
        this.onChange = fn
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn
    }

    writeValue(value: any): void {
        if(this.select)
            this.select.writeValue(value?.name ? value.name : value  )
    }

    setDisabledState(isDisabled: boolean): void {
        if(this.select)
            this.select.setDisabledState(isDisabled) // Update the internal state
    }

    @Input()
    set enum(enumName: string) {
        this.enumName = enumName
        const values = this.commonService.bootstrapData?.enums[enumName]
        this.items = values ? values : []
    }

    @Input()
    set clientEnum(enumObject: Record<string, string | number>) {
        this.items = this.enumToSelectItems(enumObject, 'enums.' + this.enumName)
    }

    private enumToSelectItems(
        enumObject: any,
        translationKey: string
    ): SelectItem[] {
        const res = Object.entries(enumObject)
            .filter(([key]) => isNaN(Number(key)))
            .map(([key, value]) => ({
                id: value as number | string,
                name: key,
                label: this.translateService.instant(`${translationKey}.${key.toLowerCase()}`)
            }));
        return res;
    }

}

